import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Divder from '../../Components/CommonComp/Divder';
import CustomBox from '../../Components/CommonComp/CustomBox/CustomBox';
import { LeftArrow } from '../../Asset/svg';
import { Typography, useTheme } from '@mui/material';
import CustomButton from '../../Components/CommonComp/Buttons/CustomButton';
import { useNavigate, useParams } from 'react-router-dom';
import OrderDetailsPage from '../../Components/Order/OrderDetailsPage';
import { useDispatch } from 'react-redux';
import { setOrderDetails } from '../../redux/orderListing';
import ModelImagesPage from '../../Components/Models/ModelImagesPage';
import ShootIDListingPages from '../../Components/Image/ShootIDListingPages';

function ShootIDListingContainerPages() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { orderId, sno, name } = useParams();
  const [showCheckbox, setShowCheckbox] = useState(false);
  const dispatch = useDispatch();
  return (
    <Box
      component="main"
      sx={(theme) => {
        return {
          flexGrow: 1,
        };
      }}
    >
      <CustomBox>
        <Box sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
          <Box sx={{
            display: "flex",
            alignItems: "center",
            cursor: 'pointer'
          }} onClick={() => {
            navigate(-1)
            dispatch(setOrderDetails({}));
            setShowCheckbox(false)
          }}>
            <LeftArrow fill={theme.palette.textButton.main} />
            <Typography variant='h5' sx={{
              marginLeft: theme.spacing(1),
              color: theme.palette.textButton.main
            }}>Back</Typography>
          </Box>
          <Typography variant='h5' sx={{ marginLeft: (theme) => theme.spacing(1) }}>{name}</Typography>
          <div style={{ paddingLeft: 30 }}></div>
        </Box>
      </CustomBox>
      <Divder spacing={1} />
      <ShootIDListingPages orderId={orderId} showCheckbox={showCheckbox} setShowCheckbox={setShowCheckbox} />
      <Divder spacing={1.2} />
    </Box>
  );
}



export default ShootIDListingContainerPages;
